import { HomePageHttpService } from './../../../http/home-page-http.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { EventsService } from 'src/app/services/events.service';
import { SharedService } from 'src/app/services/shared.service';
import { Location } from '@angular/common';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AlertComponent } from 'src/app/shared/alert/alert.component';

@UntilDestroy()
@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styles: [],
})
export class HomePageComponent implements OnInit, OnDestroy {
    constructor(
        private fb: FormBuilder,
        private homePageHttpService: HomePageHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private activatedRoute: ActivatedRoute
    ) {}

    homePageform = this.fb.group(
        {
            homePageId: [null],
            desktopAssetId: [null],
            mobileAssetId: [null],
            mainHomeFeaturedAssetId: [null],
            mainHomeFeaturedTitle: [null],
            mainHomeFeaturedDesc: [null],
            mainHomeFeaturedLink: [null],
            mainHomeFeaturedSectionId: [null],
            secondaryHomeFeaturedAssetId: [null],
            secondaryHomeFeaturedDesc: [null],
            secondaryHomeFeaturedTitle: [null],
            secondaryHomeFeaturedLink: [null],
            secondaryHomeFeaturedSectionId: [null],
        },
        { updateOn: 'submit' }
    );

    desktopAsset: any;

    mobileAsset: any;

    mainHomeFeaturedAsset: any;

    secondaryHomeFeaturedAsset: any;

    currentAsset: string;

    formBusy: boolean;

    homePage: any;

    sections: any[] = [];

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.eventsSub();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.homePage = data.data[0];
            this.sections = data.data[1];
            this.patchForm(data.data[0]);
        });
    }

    patchForm(item: any) {
        this.homePageform.patchValue(item);

        if (item.desktopAsset) {
            this.desktopAsset = item.desktopAsset;
        }

        if (item.mobileAsset) {
            this.mobileAsset = item.mobileAsset;
        }

        if (item.mainHomeFeaturedAsset) {
            this.mainHomeFeaturedAsset = item.mainHomeFeaturedAsset;
        }

        if (item.secondaryHomeFeaturedAsset) {
            this.secondaryHomeFeaturedAsset = item.secondaryHomeFeaturedAsset;
        }
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();

                switch (this.currentAsset) {
                    case 'desktopAsset':
                        if (selected) {
                            this.desktopAsset = selected;
                            this.homePageform.controls['desktopAssetId'].setValue(selected.assetId);
                        }
                        break;
                    case 'mobileAsset':
                        if (selected) {
                            this.mobileAsset = selected;
                            this.homePageform.controls['mobileAssetId'].setValue(selected.assetId);
                        }
                        break;
                    case 'mainHomeFeaturedAsset':
                        if (selected) {
                            this.mainHomeFeaturedAsset = selected;
                            this.homePageform.controls['mainHomeFeaturedAssetId'].setValue(selected.assetId);
                        }
                        break;
                    case 'secondaryHomeFeaturedAsset':
                        if (selected) {
                            this.secondaryHomeFeaturedAsset = selected;
                            this.homePageform.controls['secondaryHomeFeaturedAssetId'].setValue(selected.assetId);
                        }
                        break;
                }
            }
        });
    }

    openMedia(val: string) {
        this.currentAsset = val;
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages(val: string) {
        switch (val) {
            case 'desktopAsset':
                this.desktopAsset = null;
                this.homePageform.controls['desktopAssetId'].setValue(null);
                break;
            case 'mobileAsset':
                this.mobileAsset = null;
                this.homePageform.controls['mobileAssetId'].setValue(null);
                break;
            case 'mainHomeFeaturedAsset':
                this.mainHomeFeaturedAsset = null;
                this.homePageform.controls['mainHomeFeaturedAssetId'].setValue(null);
                break;
            case 'secondaryHomeFeaturedAsset':
                this.secondaryHomeFeaturedAsset = null;
                this.homePageform.controls['secondaryHomeFeaturedAssetId'].setValue(null);
                break;
        }
    }

    onSubmit() {
        this.homePageform.markAsTouched();
        if (this.homePageform.valid) {
            this.formBusy = true;

            if (!this.homePageform.value.homePageId) {
                delete this.homePageform.value.homePageId;
            }
            this.homePageHttpService.updateHomePage(this.homePageform.value).subscribe((data) => {
                window.scrollTo({ top: 0 });
                this.alert.addAlert({ type: 'success', message: 'HomePage Updated successfully' });
                this.formBusy = false;
            });
        }
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
